export var B2B_DOWNLOADS_LINK = "/myaccount/downloads";
